import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'romanize',
  standalone: false
})
export class RomanizePipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): unknown {
    const chars = value.split(' ');
    let final = '';
    for (const char of chars) {
      const num = Number(char);
      const digits = String(num).split('');
      const key = ['', 'C', 'CC', 'CCC', 'CD', 'D', 'DC', 'DCC', 'DCCC', 'CM',
        '', 'X', 'XX', 'XXX', 'XL', 'L', 'LX', 'LXX', 'LXXX', 'XC',
        '', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX'];
      let roman = '';
      let i = 3;
      while (i--) {
        roman = (key[+digits.pop() + (i * 10)] || '') + roman;
      }
      final += ' ' + Array(+digits.join('') + 1).join('M') + roman;
    }
    return final.trim();
  }

}
